import React from 'react';

import * as Yup from 'yup';
import { Chip } from '@material-ui/core';
import { InputFieldProps } from 'components/Forms';
import { getRequiredErrorMessageNew } from 'constants/validation';
import JobType from 'models/JobTypes';

export enum AddCapacityTypeFormFields {
  CapacityName = 'addCapacityTypeName',
  // eslint-disable-next-line @typescript-eslint/no-shadow
  JobType = 'addCapacityTypeJobType',
  Notes = 'addCapacityTypeNotes'
}

export const getAddCapacityTypeFields = (
  jobTypes?: JobType[]
): InputFieldProps[] => [
  {
    id: AddCapacityTypeFormFields.CapacityName,
    required: true,
    name: AddCapacityTypeFormFields.CapacityName,
    qaId: AddCapacityTypeFormFields.CapacityName,
    inputType: 'textfield',
    label: 'Name'
  },
  {
    id: AddCapacityTypeFormFields.JobType,
    required: true,
    name: AddCapacityTypeFormFields.JobType,
    qaId: AddCapacityTypeFormFields.JobType,
    inputType: 'multiselect',
    label: 'Job Type',
    options: !jobTypes
      ? []
      : jobTypes.map(({ name, id }) => ({
          label: name,
          value: id
        })),
    optionRenderer: props => <Chip {...props} />,
    preprocess: (items?: JobType[]) =>
      items?.map(({ id, name }) => ({
        label: name,
        value: id
      }))
  },
  {
    id: AddCapacityTypeFormFields.Notes,
    required: true,
    name: AddCapacityTypeFormFields.Notes,
    qaId: AddCapacityTypeFormFields.Notes,
    inputType: 'textarea',
    label: 'Notes',
    inputProps: {
      style: {
        height: '100%'
      }
    }
  }
];

export const validationSchema = Yup.object().shape({
  [AddCapacityTypeFormFields.CapacityName]: Yup.string().required(
    getRequiredErrorMessageNew('Name', true)
  ),
  [AddCapacityTypeFormFields.JobType]: Yup.array()
    .min(1, getRequiredErrorMessageNew('Job Type', true))
    .required(getRequiredErrorMessageNew('Job Type', true))
    .nullable(),
  [AddCapacityTypeFormFields.Notes]: Yup.string().required(
    getRequiredErrorMessageNew('Notes', true)
  )
});
